var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMigration = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#A7B9DB",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11 22L11 9",
    transform: "translate(-542 -752) translate(514 90) translate(0 642) translate(29 21)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M7 13L11 9 15 13",
    transform: "translate(-542 -752) translate(514 90) translate(0 642) translate(29 21)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M15 17.777c4.48-1.02 7.472-5.252 6.94-9.816-.53-4.564-4.415-7.994-9.01-7.959C8.337.038 4.507 3.528 4.047 8.1c-2.51.51-4.228 2.831-3.983 5.38C.31 16.028 2.44 17.98 5 18h2",
    transform: "translate(-542 -752) translate(514 90) translate(0 642) translate(29 21)"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMigration, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/migration.f65b94d4.svg";
export { ForwardRef as ReactComponent };